import {ActivatedRoute, Router} from "@angular/router";
import {Component, OnInit} from "@angular/core";
import {
  ClientContact,
  ClientITProfile,
  NetworkDescriptionAndDiagram,
  SystemInterconnection,
  SystemRolePrivilege,
  User
} from "../../_models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService,
  TenantService
} from "../../_services";
import {ConMonProfileService} from "../../_services/conMonProfile.service";
import {Access, ClientContactRole, CompanyType, DataDirection, LoginHelper, Role} from "../../helpers";
import {NameAndIdentifier} from "../../_models/nameAndIdentifier";
import {SystemLocation} from "../../_models/systemLocation";
import {Device} from "../../_models/device";
import {RoleSensitivityLevel} from "../../_models/roleSensitivityLevel";
import { OtherDesignatedContact } from "../../_models/otherDesignatedContact";
import {Constants} from "../../helpers/constants";
import {saveAs as importedSaveAs} from "file-saver";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SelectDictionaryItemComponent} from "../selectDictionaryItem/select-dictionary-item.component";
import {AddSignatureComponent} from "../addSignature/addSignature.component";

@Component({
    standalone: false,
  selector: "con-mon-profile",
  templateUrl: 'con-mon.profile.component.html',
  styleUrls: ['./con-mon.profile.component.scss'],
})

export class ConMonProfileComponent implements OnInit {
  pageTitle;
  loading = false;
  currentUser: User;
  conMonProfileId: number;
  formGroup: FormGroup;
  lowMediumHigh = {0: 'Low (L)', 1: 'Moderate (M)', 2: 'High (H)'};
  profiles: any[] = [];
  profile: any;
  window = window;
  token: string;
  api: any;
  projects: any[];
  projectControlItems: any[];
  itProfiles: any[];
  projectItProfiles: any[];

  rowGroupMetadata = {};

  selectedProjectControlItems = [];

  zipFileCols: any[] = [
    {field: 'title', header: 'Title', width: '50%'},
    {field: 'fileName', header: 'File Name (Include Extension)', width: '50%'},
  ];
  zipFileFormGroup: FormGroup;
  zipFileDialogVisible = false;
  editedZipFile: any;
  editedZipFileKey: string;
  zipFiles: any = {};
  constants = Constants;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public clientProfileService: ClientProfileService,
    public _formBuilder: FormBuilder,
    public conMonProfileService: ConMonProfileService,
    public dialog: MatDialog,
    public fileBlobService: FileBlobService,
    public tenantService: TenantService,
    public alertService: AlertService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.api = window.location.origin || Constants.DefaultApiHost;
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['ConMon'] || 'Package Profiles');
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.clientProfileService.getClientProfiles(tenantName).subscribe(s => {
      this.itProfiles = s;
    });

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.zipFileFormGroup = this._formBuilder.group({
      title: ['', Validators.required],
      fileName: ['', Validators.required],
      kind: [0]
    });

    this.formGroup = this._formBuilder.group({
      conMonProfileId: [0],
      name: ['', Validators.required],
      preparedByName: [''],
      notes: [''],
      datesType: [0],
      initialStart: [new Date()],
      initialEnd: [new Date()],
      remediationStart: [new Date()],
      remediationEnd: [new Date()],
      assessmentStart: [new Date()],
      assessmentEnd: [new Date()],
      baselineInitial: [0],
      baselineAnnual: [0],
      isForAlsoIncludes: [0],
      changeChanges: [0],
      aoJab: [0],
      relatedActivities: [0],
      includingThoseApplicable: [false],
      sapVersion: [''],
      sapVersionDate: [new Date()],
      testingTypesManual: [false],
      testingTypesPenetration: [false],
      testingTypesWeb: [false],
      testingTypesBenchmark: [false],
      testingTypesDatabase: [false],
      testingTypesOperationSystem: [false],
      testingTypesContainer: [false],
      recommendsName: [''],
      notRecommendsName: [''],
      recommendsContinued: [''],
      notRecommendsContinued: [''],
      recommendsAssessment: [''],
      isRecommendsAssessmentMultiple: [false],
      approvedSignificantChanges: [''],
      notRecommendsAssessment: [''],
      isNotRecommendsAssessmentMultiple: [false],
      notApprovedSignificantChanges: [''],
//      retTableId: [0],
//      srtmWorkbookId: [0],
      infrastructureScannerName: [''],
      infrastructureScannerVendor: [''],
      infrastructureScannerVersion: [''],
      infrastructurePercentageScanned: [0],
      isInfrastructureDiscrepancy: [false],
      infrastructureDiscrepancyReasons: [''],
      infrastructureScanDate: [new Date()],
      dbScannerName: [''],
      dbScannerVendor: [''],
      dbScannerVersion: [''],
      dbPercentageScanned: [0],
      isDbScan: [false],
      isDbDiscrepancy: [false],
      dbDiscrepancyReasons: [''],
      dbScanDate: [new Date()],
      webScannerName: [''],
      webScannerVendor: [''],
      webScannerVersion: [''],
      webPercentageAppScanned: [0],
      webPercentageApiScanned: [0],
      isWebScan: [false],
      isWebDiscrepancy: [false],
      webDiscrepancyReasons: [''],
      webScanDate: [new Date()],
      benchmarkScannerName: [''],
      benchmarkScannerVendor: [''],
      benchmarkScannerVersion: [''],
      benchmarkPercentageAppScanned: [0],
      benchmarkPercentageApiScanned: [0],
      isBenchmarkScan: [false],
      isBenchmarkDiscrepancy: [false],
      benchmarkDiscrepancyReasons: [''],
      benchmarkScanDate: [new Date()],
      containerScannerName: [''],
      containerScannerVendor: [''],
      containerScannerVersion: [''],
      containerPercentageScanned: [0],
      isContainerScan: [false],
      isContainerDiscrepancy: [false],
      containerDiscrepancyReasons: [''],
      containerScanDate: [new Date()],
      otherScanDate: [new Date()],
      penTestLocation: [''],
      penTestDate: [new Date()],
      projectId: [null],
      startDate: [new Date()],
      endDate: [new Date()],
      includeDbScans: [false],
      includeHighRiskVulnerabilities: [false],
      includeEvidence: [false],
      includeAppScans: [false],
      includePoamReports: [false],
      includeDocumentation: [false],
      includeContainerScans: [false],
      includePolicies: [false],
      includeInfrastructureScans: [false],
      includeIncidents: [false],
      clientItProfileId: [null],
      signedName: [''],
      signedDate: [null],
      attestationLetter: ['']
      //penTestId: [0],
    });

    this.route.params.subscribe(p => {
      this.conMonProfileId = +p['id'];
      this.loadProfiles();
    });
  }

  loadProfiles() {
    this.conMonProfileService.getConMonProfiles()
      .subscribe((profiles: any[]) => {

        if (profiles == null) {
          return;
        }

        this.profiles = profiles;
        this.profile = profiles.find(p => p.conMonProfileId == this.conMonProfileId);
        if (!this.profile && this.profiles.length) {
          this.router.navigate(['/profiles', 'conMonProfile', this.profiles[0].conMonProfileId]);
        } else {
          this.selectProfile(this.profile);
        }
      });
  }

  onProfileChanged(event) {
    this.router.navigate(['/profiles/conMonProfile', event.value]);
  }

  createProfile() {
    this.conMonProfileService
      .saveConMonProfile({name: 'Package'})
      .subscribe((r) => this.router.navigate(['/profiles/conMonProfile', r.conMonProfileId]));
  }

  selectProfile(profile) {
    this.projectService.getAllShort().subscribe(p => {
      this.projects = p;
      this.selectProject(profile.projectId || p[0].projectId);

    });

    if (!profile) {
      profile = {
        conMonProfileId: 0,
        name: '',
        preparedByName: '',
        notes: '',
        assessmentType: 0,
        datesType: 0,
        initialStart: new Date(),
        initialEnd: new Date(),
        remediationStart: new Date(),
        remediationEnd: new Date(),
        assessmentStart: new Date(),
        assessmentEnd: new Date(),
        baselineInitial: 0,
        baselineAnnual: 0,
        isForAlsoIncludes: 0,
        changeChanges: 0,
        aoJab: 0,
        relatedActivities: 0,
        includingThoseApplicable: false,
        sapVersion: '',
        sapVersionDate: new Date(),
        testingTypesManual: false,
        testingTypesPenetration: false,
        testingTypesWeb: false,
        testingTypesBenchmark: false,
        testingTypesDatabase: false,
        testingTypesOperationSystem: false,
        testingTypesContainer: false,
        recommendsName: '',
        notRecommendsName: '',
        recommendsContinued: '',
        notRecommendsContinued: '',
        recommendsAssessment: '',
        isRecommendsAssessmentMultiple: false,
        approvedSignificantChanges: '',
        notRecommendsAssessment: '',
        isNotRecommendsAssessmentMultiple: false,
        notApprovedSignificantChanges: '',
//      retTableId: 0,
//      srtmWorkbookId: 0,
        infrastructureScannerName: '',
        infrastructureScannerVendor: '',
        infrastructureScannerVersion: '',
        infrastructurePercentageScanned: 0,
        isInfrastructureDiscrepancy: false,
        infrastructureDiscrepancyReasons: '',
        infrastructureScanDate: new Date(),
        dbScannerName: '',
        dbScannerVendor: '',
        dbScannerVersion: '',
        dbPercentageScanned: 0,
        isDbScan: false,
        isDbDiscrepancy: false,
        dbDiscrepancyReasons: '',
        dbScanDate: new Date(),
        webScannerName: '',
        webScannerVendor: '',
        webScannerVersion: '',
        webPercentageAppScanned: 0,
        webPercentageApiScanned: 0,
        isWebScan: false,
        isWebDiscrepancy: false,
        webDiscrepancyReasons: '',
        webScanDate: new Date(),
        benchmarkScannerName: '',
        benchmarkScannerVendor: '',
        benchmarkScannerVersion: '',
        benchmarkPercentageAppScanned: 0,
        benchmarkPercentageApiScanned: 0,
        isBenchmarkScan: false,
        isBenchmarkDiscrepancy: false,
        benchmarkDiscrepancyReasons: '',
        benchmarkScanDate: new Date(),
        containerScannerName: '',
        containerScannerVendor: '',
        containerScannerVersion: '',
        containerPercentageScanned: 0,
        isContainerScan: false,
        isContainerDiscrepancy: false,
        containerDiscrepancyReasons: '',
        containerScanDate: new Date(),
        otherScanDate: new Date(),
        penTestLocation: '',
        penTestDate: new Date(),
        projectId: null,
        startDate: null,
        endDate: null,
        includeDbScans: false,
        includeHighRiskVulnerabilities: false,
        includeEvidence: false,
        includeAppScans: false,
        includePoamReports: false,
        includeDocumentation: false,
        includeContainerScans: false,
        includePolicies: false,
        includeInfrastructureScans: false,
        includeIncidents: false,
        clientItProfileId: null,
        signedName: '',
        signedDate: null,
        attestationLetter: ''
        //penTestId: 0,
      };
    }

    this.profile = profile;

    profile.conMonFiles = profile.conMonFiles || [];
    this.zipFiles['Infrastructure'] = profile.conMonFiles.filter(s => s.kind === 0);
    this.zipFiles['Db'] = profile.conMonFiles.filter(s => s.kind === 1);
    this.zipFiles['Web'] = profile.conMonFiles.filter(s => s.kind === 2);
    this.zipFiles['Benchmark'] = profile.conMonFiles.filter(s => s.kind === 5);
    this.zipFiles['Container'] = profile.conMonFiles.filter(s => s.kind === 3);
    this.zipFiles['Other'] = profile.conMonFiles.filter(s => s.kind === 4);

    this.formGroup.patchValue({
      conMonProfileId: this.profile.conMonProfileId,
      name: this.profile.name,
      version: this.profile.name,
      date: this.profile.date,
      preparedByName: this.profile.preparedByName,
      notes: this.profile.notes,
      datesType: this.profile.datesType,
      initialStart: this.profile.initialStart,
      initialEnd: this.profile.initialEnd,
      remediationStart: this.profile.remediationStart,
      remediationEnd: this.profile.remediationEnd,
      assessmentStart: this.profile.assessmentStart,
      assessmentEnd: this.profile.assessmentEnd,
      baselineInitial: this.profile.baselineInitial,
      baselineAnnual: this.profile.baselineAnnual,
      isForAlsoIncludes: this.profile.isForAlsoIncludes,
      changeChanges: this.profile.changeChanges,
      aoJab: this.profile.aoJab,
      relatedActivities: this.profile.relatedActivities,
      includingThoseApplicable: this.profile.includingThoseApplicable,
      sapVersion: this.profile.sapVersion,
      sapVersionDate: this.profile.sapVersionDate,
      testingTypesManual: (this.profile.testingTypes & 1) !== 0,
      testingTypesPenetration: (this.profile.testingTypes & 1) !== 0,
      testingTypesWeb: (this.profile.testingTypes & 1) !== 0,
      testingTypesBenchmark: (this.profile.testingTypes & 1) !== 0,
      testingTypesDatabase: (this.profile.testingTypes & 1) !== 0,
      testingTypesOperationSystem: (this.profile.testingTypes & 1) !== 0,
      testingTypesContainer: (this.profile.testingTypes & 1) !== 0,
      recommendsName: this.profile.recommendsName,
      notRecommendsName: this.profile.notRecommendsName,
      recommendsContinued: this.profile.recommendsContinued,
      notRecommendsContinued: this.profile.notRecommendsContinued,
      recommendsAssessment: this.profile.recommendsAssessment,
      isRecommendsAssessmentMultiple: this.profile.isRecommendsAssessmentMultiple,
      approvedSignificantChanges: this.profile.approvedSignificantChanges,
      notRecommendsAssessment: this.profile.notRecommendsAssessment,
      isNotRecommendsAssessmentMultiple: this.profile.isNotRecommendsAssessmentMultiple,
      notApprovedSignificantChanges: this.profile.notApprovedSignificantChanges,
//      retTableId: retTableId,
//      srtmWorkbookId: srtmWorkbookId,
      infrastructureScannerName: this.profile.infrastructureScannerName,
      infrastructureScannerVendor: this.profile.infrastructureScannerVendor,
      infrastructureScannerVersion: this.profile.infrastructureScannerVersion,
      infrastructurePercentageScanned: this.profile.infrastructurePercentageScanned,
      isInfrastructureDiscrepancy: this.profile.isInfrastructureDiscrepancy,
      infrastructureDiscrepancyReasons: this.profile.infrastructureDiscrepancyReasons,
      infrastructureScanDate: this.profile.infrastructureScanDate,
      dbScannerName: this.profile.dbScannerName,
      dbScannerVendor: this.profile.dbScannerVendor,
      dbScannerVersion: this.profile.dbScannerVersion,
      dbPercentageScanned: this.profile.dbPercentageScanned,
      isDbScan: this.profile.isDbScan,
      isDbDiscrepancy: this.profile.isDbDiscrepancy,
      dbDiscrepancyReasons: this.profile.dbDiscrepancyReasons,
      dbScanDate: this.profile.dbScanDate,
      webScannerName: this.profile.webScannerName,
      webScannerVendor: this.profile.webScannerVendor,
      webScannerVersion: this.profile.webScannerVersion,
      webPercentageAppScanned: this.profile.webPercentageAppScanned,
      webPercentageApiScanned: this.profile.webPercentageApiScanned,
      isWebScan: this.profile.isWebScan,
      isWebDiscrepancy: this.profile.isWebDiscrepancy,
      webDiscrepancyReasons: this.profile.webDiscrepancyReasons,
      webScanDate: this.profile.webScanDate,
      benchmarkScannerName: this.profile.benchmarkScannerName,
      benchmarkScannerVendor: this.profile.benchmarkScannerVendor,
      benchmarkScannerVersion: this.profile.benchmarkScannerVersion,
      benchmarkPercentageAppScanned: this.profile.benchmarkPercentageAppScanned,
      benchmarkPercentageApiScanned: this.profile.benchmarkPercentageApiScanned,
      isBenchmarkScan: this.profile.isBenchmarkScan,
      isBenchmarkDiscrepancy: this.profile.isBenchmarkDiscrepancy,
      benchmarkDiscrepancyReasons: this.profile.benchmarkDiscrepancyReasons,
      benchmarkScanDate: this.profile.benchmarkScanDate,
      containerScannerName: this.profile.containerScannerName,
      containerScannerVendor: this.profile.containerScannerVendor,
      containerScannerVersion: this.profile.containerScannerVersion,
      containerPercentageScanned: this.profile.containerPercentageScanned,
      isContainerScan: this.profile.isContainerScan,
      isContainerDiscrepancy: this.profile.isContainerDiscrepancy,
      containerDiscrepancyReasons: this.profile.containerDiscrepancyReasons,
      containerScanDate: this.profile.containerScanDate,
      otherScanDate: this.profile.otherScanDate,
      penTestLocation: this.profile.penTestLocation,
      penTestDate: this.profile.penTestDate,
      projectId: this.profile.projectId,
      startDate: this.profile.startDate,
      endDate: this.profile.endDate,
      includeDbScans: this.profile.includeDbScans,
      includeHighRiskVulnerabilities: this.profile.includeHighRiskVulnerabilities,
      includeEvidence: this.profile.includeEvidence,
      includeAppScans: this.profile.includeAppScans,
      includePoamReports: this.profile.includePoamReports,
      includeDocumentation: this.profile.includeDocumentation,
      includeContainerScans: this.profile.includeContainerScans,
      includePolicies: this.profile.includePolicies,
      includeInfrastructureScans: this.profile.includeInfrastructureScans,
      includeIncidents: this.profile.includeIncidents,
      clientItProfileId: this.profile.clientItProfileId,
      signedName: this.profile.signedName,
      signedDate: this.profile.signedDate,
      attestationLetter: this.profile.attestationLetter
      //penTestId: 0,
    });
  }

  selectProject(projectId) {
    this.projectService.getById(projectId).subscribe(
      p => {
        this.projectControlItems = p.projectControlItems;
        this.projectControlItems.forEach(s => s.checked = (this.profile.projectControlItemIds || []).indexOf(s.projectControlItemId) >= 0);
        console.log(p.projectControlItems)
        this.updateRowGroupMetaData(p.projectControlItems);
        this.projectItProfiles = (p.clientITProfileIds || '').split(';').map(i => this.itProfiles.find(p => p.clientITProfileId == i)).filter(p => p);
      });

  }

  projectChanged(e) {
    this.selectProject(e.value);
  }

  onDone() {
    if (!this.formGroup.valid) return;
    this.alertService.clear();
    const value = {
      ...this.profile, ...this.formGroup.value,
      conMonFiles: [...this.zipFiles['Infrastructure'] || [], ...this.zipFiles['Db'] || [], ...this.zipFiles['Web'] || [], ...this.zipFiles['Benchmark'] || [], ...this.zipFiles['Container'] || [], ...this.zipFiles['Other'] || []],
      projectControlItems: (this.projectControlItems || []).filter(p => p.checked)
    };
    value.testingTypes = (this.formGroup.value.testingTypesManual ? 1 : 0) +
      (this.formGroup.value.testingTypesPenetration ? 1 : 0) +
      (this.formGroup.value.testingTypesWeb ? 1 : 0) +
      (this.formGroup.value.testingTypesBenchmark ? 1 : 0) +
      (this.formGroup.value.testingTypesDatabase ? 1 : 0) +
      (this.formGroup.value.testingTypesOperationSystem ? 1 : 0) +
      (this.formGroup.value.testingTypesContainer ? 1 : 0);

    this.conMonProfileService.saveConMonProfile(value)
      .subscribe(() => {
          this.alertService.success("Profile Successfully Saved");
          this.loadProfiles();
        },
        error => {
          const errorMessage = 'An error occurred while updating client Package.';
          this.alertService.error(errorMessage);
        }
      );
  }

  removeProfile() {
    this.conMonProfileService.deleteConMonProfile(this.profile.conMonProfileId).subscribe(() => {
      this.router.navigate(['/profiles/conMonProfile']);
    });
  }


  showZipFileDialog(item, list) {
    this.editedZipFile = item;
    this.editedZipFileKey = list;
    this.zipFileFormGroup.setValue({
      title: item.title || '',
      fileName: item.fileName || '',
      kind: item.kind
    });
    this.zipFileDialogVisible = true;
  }

  saveZipFile() {
    if (!this.zipFileFormGroup.valid) {
      Object.keys(this.zipFileFormGroup.controls).forEach(field => {
        const control = this.zipFileFormGroup.get(field);
        control.markAsTouched({onlySelf: true});
      });
      return;
    }
    const data = {...this.editedZipFile, ...this.zipFileFormGroup.value};
    const pos = this.zipFiles[this.editedZipFileKey].indexOf(this.editedZipFile);
    if (pos >= 0) {
      this.zipFiles[this.editedZipFileKey][pos] = {...this.editedZipFile, ...data};
    } else {
      this.zipFiles[this.editedZipFileKey].push({...data});
    }
    this.zipFiles[this.editedZipFileKey] = [...this.zipFiles[this.editedZipFileKey]];
    this.zipFileDialogVisible = false;
    this.editedZipFile = null;
  }

  public AddZipFile(event) {

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.conMonProfileService.postZipFile(file, LoginHelper.getUserId())
        .subscribe((res) => {

            this.editedZipFile.conMonFileAttachment = res;
            this.editedZipFile.conMonFileAttachmentId = res.conMonFileAttachmentId;
            this.editedZipFile.fileName = res.name;
            this.editedZipFile.internalName = res.internalName;
            this.zipFileFormGroup.setValue({...this.zipFileFormGroup.value, fileName: res.name});

          });
    }
  }

  selectAllProjectControlItems(event) {
    this.projectControlItems.forEach(i => i.checked = event.checked.length > 0);
  }

  deleteZipFile(item, key) {
    this.zipFiles[key].splice(this.zipFiles[key].indexOf(item, 1));
    this.zipFiles[key] = [...this.zipFiles[key]];
  }


  updateRowGroupMetaData(data) {
    this.rowGroupMetadata = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  download(){
    this.conMonProfileService.downloadSsp(this.conMonProfileId).subscribe(blob => {
        importedSaveAs(new Blob([blob]), 'Package.zip');
      },
      error => {
        const errorMessage = 'Error during download';
        this.alertService.error(errorMessage);
      });
  }

  sign() {
    let config: MatDialogConfig = {
      data: {
      }
    };

    let dialogRef = this.dialog.open(AddSignatureComponent, config);

    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.formGroup.patchValue({signedName: data.name, signedDate: data.date});
      }
    });
  }

  copy(){
    const copy = {...this.profile, conMonProfileId: 0, conMonFiles: (this.profile.conMonFiles || []).map(c => ({...c, conMonFileId: 0, conMonProfileId: 0}))};
    this.conMonProfileService.saveConMonProfile(copy)
      .subscribe(() => {
          this.alertService.success("Profile Successfully Copied");
          this.loadProfiles();
        },
        error => {
          const errorMessage = 'An error occurred while copying client Package.';
          this.alertService.error(errorMessage);
        }
      );
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}
